<template>
  <div class="security-information">
    <img class="security-image" :src="require('@/assets/onboarding/security-top-image.svg')"/>
    <div class="description">
      <div class="title">בואו נדבר על הפיל שבחדר</div>
      <div class="subtitle">כדי לבנות לך תמונת מצב מדויקת ותזרים חודשי, המערכת צריכה גישה לחשבונות</div>
      <div class="explanation">הגישה לחשבונות היא
        <span class="bold"> רק בשביל קריאת הנתונים </span>והמערכת אף פעם לא תבצע פעולות בחשבון שלך.
      </div>
    </div>
    <div class="video-wrapper">
      <div class="top-bar">
        <div class="title-wrapper">
          <div class="title">צפו ביפתח בר, סמנכ״ל הפיתוח שלנו <span class="bold">מסביר על אבטחת המידע ב-riseup</span></div>
        </div>
        <img class="shield" :src="require('@/assets/onboarding/icons/shield_square.svg')"/>
      </div>
      <div class="video-container">
        <video ref="iftachvideo"
               v-on:click="stop" class="video"
               :src="'https://video.wixstatic.com/video/5e670d_69eedbb5d08d4b668432a73ca2051b5d/1080p/mp4/file.mp4#t=0.001'"/>
        <img class="play-button" v-if="!isPlaying" v-on:click="play" :src="require('@/assets/onboarding/icons/play-btn.svg')"/>
      </div>
    </div>
    <div class="disclaimers-wrapper">
      <div class="title">פרטיות המידע שלך היא הדבר החשוב ביותר. אנחנו בשום פנים ואופן:</div>
      <div class="disclaimer-container">
        <img class="no-icon" :src="require('@/assets/onboarding/icons/no-icon.svg')"/>
        <div class="disclaimer"><span class="bold">לא נמכור </span>את המידע האישי שלך</div>
      </div>
      <div class="disclaimer-container">
        <img class="no-icon" :src="require('@/assets/onboarding/icons/no-icon.svg')"/>
        <div class="disclaimer"><span class="bold">לא נעביר </span>את המידע שלך לצד ג׳</div>
      </div>
      <div class="disclaimer-container">
        <img class="no-icon" :src="require('@/assets/onboarding/icons/no-icon.svg')"/>
        <div class="disclaimer"><span class="bold">לא נבצע </span>פעולות בחשבון שלך</div>
      </div>
    </div>
    <div class="information-security">
      <div class="security-third-parties">
        <div class="title">איך אנחנו שומרים על המידע שלך:</div>
        <div class="third-party">
          <div class="circle-wrapper">
            <div class="circle">
              <img class="v-logo" :src="require('@/assets/onboarding/icons/icon-small-check.svg')">
            </div>
          </div>
          <div class="security-description">מצפינים ומאבטחים את המידע שלך בשרתי <span class="bold">Amazon</span> תחת סטנדרט אבטחה עולמי.</div>
        </div>
        <div class="third-party">
          <div class="circle-wrapper">
            <div class="circle">
              <img class="v-logo" :src="require('@/assets/onboarding/icons/icon-small-check.svg')">
            </div>
          </div>
          <div class="security-description">שומרים את המידע שלך כמאגר בפיקוח <span class="bold">הרשות להגנת הפרטיות</span> של משרד המשפטים.</div>
        </div>
        <div class="third-party">
          <div class="circle-wrapper">
            <div class="circle">
              <img class="v-logo" :src="require('@/assets/onboarding/icons/icon-small-check.svg')">
            </div>
          </div>
          <div class="security-description">מפעילים בשבילך ביטוח אחריות מקצועי עם ״<span class="bold">הפניקס</span>״,
            חברת הביטוח המובילה בישראל.</div>
        </div>
      </div>
      <div class="logo-wrapper">
        <img class="logos" :src="require('@/assets/onboarding/security-logos.png')"/>
      </div>
    </div>
    <div v-if="showTerms" class="agreement">
      <div class="checkbox-wrapper">
        <div class="checkbox" @click="checkAgreement()">
          <img :src="require('@/assets/icons/v-blue.svg')" class="checkmark" v-if="agreed">
        </div>
      </div>
      <div class="policy">
        קראתי ואישרתי את
        <span class="link" @click="openTerm()">תנאי השימוש והפרטיות.</span>
      </div>
    </div>
    <div class="button-wrapper">
      <riseup-button class="button" :size="'small'" :disabled="disabled" :title="'הבנתי, אפשר להמשיך!'" :action="confirm"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import featureFlag from '@/api/featureFlag';
import BaseUI from 'base-ui';
import Segment from '../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('SecurityPageEntered');
    this.showTerms = (await featureFlag.getAnonymousTreatment('show_terms_in_intro')) !== 'on';
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  name: 'SecurityInformation',
  data() {
    return {
      isPlaying: false,
      agreed: false,
      showTerms: false,
    };
  },

  computed: {
    disabled() {
      return this.showTerms && !this.agreed;
    },
  },
  methods: {
    ...mapActions('onboardingState', ['securityInformationSubmit']),
    confirm() {
      Segment.trackUserInteraction('SecurityPageNextClicked');
      this.securityInformationSubmit();
    },
    play() {
      Segment.trackUserInteraction('SecurityVideoPlayClicked');
      this.$refs.iftachvideo.play();
      this.isPlaying = true;
    },
    stop() {
      if (this.isPlaying) {
        this.$refs.iftachvideo.pause();
        this.isPlaying = false;
      }
    },
    openTerm() {
      window.open('/terms', '_blank');
    },
    checkAgreement() {
      this.agreed = !this.agreed;
      Segment.trackUserInteraction('TermsAgreedChecked', { agreed: this.agreed });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .security-information {
    .security-image {
      width: 100%;
    }

    .description {
      @include responsive-padding;
      margin: 40px 0;
      font-family: SimplerPro;

      .title {
        font-size: 15px;
        font-weight: bold;
        color: $riseup_blue;
        margin-bottom: 20px;
      }

      .subtitle {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        margin-bottom: 20px;
      }

      .explanation {
        font-size: 18px;
        line-height: 1.44;

        .bold {
          font-weight: bold;
        }
      }
    }

    .video-wrapper {
      width: 100%;

      .top-bar {
        display: flex;
        width: 100%;
        height: 90px;

        .title-wrapper {
          background-color: $riseup_blue;
          display: flex;
          align-items: center;
          @include responsive-padding;
          width: 100%;

          .title {
            color: $riseup_white;
            font-size: 14px;
            line-height: 1.36;
            font-family: SimplerPro;

            .bold {
              font-weight: bold;
            }
          }
        }

        .shield {
          width: 90px;
          background-color: $riseup_dark_blue;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .video-container {
        width: 100%;
        position: relative;

        .video {
          width: 100%;
        }

        .play-button {
          position: absolute;
          width: 80px;
          height: 80px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .disclaimers-wrapper {
      @include responsive-padding;
      margin: 40px 0 50px;
      font-family: SimplerPro;

      .title {
        font-size: 22px;
        line-height: 1.27;
        font-weight: bold;
        margin-bottom: 30px;
      }

      .disclaimer-container {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        .no-icon {
          height: 30px;
          margin-left: 20px;
        }

        .disclaimer {
          font-size: 18px;
          font-family: SimplerPro;

          .bold {
            font-weight: bold;
          }
        }
      }
    }

    .information-security {
      background-color: $riseup_light_blue;
      @include responsive-padding;
      padding-top: 45px;
      padding-bottom: 50px;

      .privacy {
        font-size: 18px;
        line-height: 1.44;
        font-family: SimplerPro;
        margin-bottom: 40px;

        .title {
          color: $riseup_blue;
          font-weight: bold;
          margin-bottom: 20px;
        }
      }

      .security-third-parties {
        margin-bottom: 60px;

        .title {
          font-size: 22px;
          line-height: 1.44;
          font-family: SimplerPro;
          font-weight: bold;
          color: $riseup_blue;
          margin-bottom: 30px;
          margin-left: 20px;
        }

        .third-party {
          display: flex;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 30px;

          .circle-wrapper {
            width: 50px;
            .circle {
              height: 30px;
              width: 30px;
              border-radius: 50%;
              background-color: $riseup_blue;
              display: flex;
              align-items: center;
              justify-content: center;

              .v-logo {
                height: 12px;
              }
            }
          }

          .security-description {
            flex-grow: 1;
            width: 100%;
            font-size: 17px;
            font-family: SimplerPro;
            line-height: 1.3;

            .bold {
              font-weight: bold;
            }
          }
        }
      }
      .logo-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .logos {
          width: 90%;
        }
      }
    }

    .agreement {
      @include responsive-padding;
      display: flex;
      align-items: center;
      margin-top: 20px;

      .checkbox-wrapper {
        width: 45px;

        .checkbox {
          flex: 0 0 28px;
          height: 25px;
          width: 25px;
          border-radius: 4px;
          border: solid 2px $riseup_gray_1;
          cursor: pointer;

          .checkmark {
            height: 20px;
            width: 20px;
          }
        }
      }

      .policy {
        font-size: 14px;

        .link {
          color: $riseup_blue;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .button-wrapper {
      @include responsive-padding-top-bottom;
      @include responsive-padding;
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }

</style>
